class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('[data-slider="cards-container"]');
    this.previous = this.querySelector('[data-slider="left"]');
    this.next = this.querySelector('[data-slider="right"]');
    this.breakPoint = window.matchMedia('(max-width: 749px)');
    this.slidedCards = this.breakPoint.matches ? this.container.dataset.slideOnPhone : this.container.dataset.slideOnDesktop;
    this.cardWidth = this.querySelector('[data-slider="card"]').offsetWidth;
    this.containerStyle = window.getComputedStyle(this.container);
    this.gap = +(this.containerStyle.gap.replace('px', ''));
    this.slideOffset = (this.cardWidth + this.gap) * this.slidedCards;

    this.setupEventListeners();
    this.checkButtons();
  }

  setupEventListeners() {
    this.container.addEventListener('scroll', this.checkButtons.bind(this));
    this.previous.addEventListener('click', this.slide.bind(this, 'left'));
    this.next.addEventListener('click', this.slide.bind(this, 'right'));
  }

  disable(element) {
    element.classList.add('disabled');
  }

  enable(element) {
    element.classList.remove('disabled');
  }

  checkButtons() {
    if (this.container.scrollWidth - this.container.scrollLeft <= this.container.offsetWidth || this.container.offsetWidth >= this.container.scrollWidth ) {
      this.disable(this.next);
    } else {
      this.enable(this.next);
    }
    this.container.scrollLeft > 0 ? this.enable(this.previous) : this.disable(this.previous);
  }

  slide(direction) {
    direction == 'right' ? this.container.scrollLeft = this.container.scrollLeft + this.slideOffset : this.container.scrollLeft = this.container.scrollLeft - this.slideOffset;
    setTimeout(() => this.checkButtons(), this.slidedCards * 250);
  }
}

customElements.define('slider-component', SliderComponent);
